module.exports = __webpack_public_path__ + "static/hit_3-1fc2c6482ae64930b34890b393449b3f.png";